import { useQuery } from "@tanstack/react-query";
import { getSucursaleUe } from "@/api/endpoints/sucursaleUe";
import { queryKeys } from "@/lib/queryClient";
import type { GetSucursaleUeResponse } from "@/api/types/sucursaleUe";

export function useGetSucursaleUe(cui: string | undefined) {
  return useQuery<GetSucursaleUeResponse, Error>({
    queryKey: queryKeys.sucursaleUe.byCui(cui || ""),
    queryFn: () => getSucursaleUe({ cui: cui! }),
    enabled: Boolean(cui && cui.length >= 2),
    retry: false,
  });
}
